var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0759 13.3904C2.30803 12.6225 2.30803 11.3775 3.07591 10.6096L11.1096 2.5759C11.8775 1.80803 13.1225 1.80803 13.8904 2.57591L21.9241 10.6096C22.692 11.3775 22.692 12.6225 21.9241 13.3904L13.8904 21.4241C13.1225 22.192 11.8775 22.192 11.1096 21.4241L3.0759 13.3904ZM12.5 20.5204L21.0204 12L12.5 3.47964L3.97964 12L12.5 20.5204ZM13.4001 14H11.6001V7H13.4001V14ZM11.5786 15.5023C11.456 15.6881 11.3906 15.9065 11.3906 16.13C11.3906 16.2784 11.4195 16.4254 11.4755 16.5625C11.5316 16.6996 11.6138 16.8241 11.7174 16.9291C11.821 17.034 11.944 17.1173 12.0793 17.174C12.2147 17.2308 12.3597 17.26 12.5062 17.26C12.7269 17.26 12.9425 17.1937 13.126 17.0696C13.3095 16.9454 13.4525 16.769 13.5369 16.5625C13.6213 16.356 13.6434 16.1287 13.6004 15.9095C13.5573 15.6903 13.4511 15.4891 13.2951 15.331C13.139 15.173 12.9403 15.0653 12.7239 15.0217C12.5075 14.9781 12.2832 15.0005 12.0793 15.086C11.8755 15.1716 11.7012 15.3165 11.5786 15.5023Z",
    fill: "#CC0511"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d912f50f121c0448cb02321da8da4ddf.svg";
export { ForwardRef as ReactComponent };